import React from 'react';
import styled from 'styled-components';

const FaceGroup = styled.g``;
export interface Props {
  color?: string;
  skinColor?: string;
  cheekColor?: string;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function Face({ color, skinColor, cheekColor }: Props) {
  return (
    <FaceGroup className="face">
      {/* 오른 귀 */}
      <path
        className="right-ear"
        d="M85 67.1466C85 61.1466 80 60.6466 77.5 61.1466C76.1667 61.1466 73.4 62.0466 73 65.6465C72.6 69.2465 73.8333 72.8132 74.5 74.1465C78 74.3132 85 73.1466 85 67.1466Z"
        fill={skinColor}
        stroke={color}
      />
      {/* 왼쪽귀 */}
      <path
        className="left-ear"
        d="M15 67.1466C15 61.1466 20 60.6466 22.5 61.1466C23.8333 61.1466 26.6 62.0466 27 65.6465C27.4 69.2465 26.1667 72.8132 25.5 74.1465C22 74.3132 15 73.1466 15 67.1466Z"
        fill={skinColor}
        stroke={color}
      />
      {/* 얼굴 - 정면 */}
      <path
        className="face-front"
        d="M49.1922 86C23.5683 86 21.1589 69.1239 21.1589 60.3997C21.1589 46.503 17.1675 18 49.1922 18C80.3322 18 79.3991 47.3174 78.8274 60.3997C78.4461 69.1239 77.2254 86 49.1922 86Z"
        fill={skinColor}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* 얼굴-측면 */}
      <path
        className="face-side"
        d="M49.1922 85C18 85 21.1589 68.1239 21.1589 59.3997C21.1589 45.503 17.1675 17 49.1922 17C80.3322 17 79.3991 46.3174 78.8274 59.3997C78.4461 68.1239 78.8274 85 49.1922 85Z"
        fill={skinColor}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* 왼/오른뺨 - 정면*/}
      <path
        className="face-front"
        d="M61.4244 75.7146C66.0546 71.9862 71.0707 75.1968 73 77.2681C71.7373 80.5822 65.1076 83.1369 61.9505 84C59.8459 82.7917 56.7941 79.443 61.4244 75.7146Z"
        fill={cheekColor}
      />
      <path
        className="face-front"
        d="M38.5756 75.7146C33.9454 71.9862 28.9293 75.1968 27 77.2681C28.2627 80.5822 34.8924 83.1369 38.0495 84C40.1541 82.7917 43.2059 79.443 38.5756 75.7146Z"
        fill={cheekColor}
      />

      {/* 왼/오른뺨 - 측면*/}
      <path
        className="face-side"
        d="M61.4244 74.7146C66.0546 70.9862 71.0707 74.1968 73 76.2681C71.7373 79.5822 65.1076 82.1369 61.9505 83C59.8459 81.7917 56.7941 78.443 61.4244 74.7146Z"
        fill={cheekColor}
      />
      <path
        className="face-side"
        d="M36.5756 74.7146C31.9454 70.9862 26.9293 74.1968 25 76.2681C26.2627 79.5822 32.8924 82.1369 36.0495 83C38.1541 81.7917 41.2059 78.443 36.5756 74.7146Z"
        fill={cheekColor}
      />
    </FaceGroup>
  );
}

export default Face;
